var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page"},[_c('h1',[_vm._v("Тайный санта Crysto")]),_c('a',{attrs:{"href":_vm.authLink}},[_c('c-button',{staticClass:"auth-button"},[_vm._v("Авторизация через вк")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }